import regex from '../shop/constants/regex';

export default { email: (email) => regex.EMAIL_REGEX.test(email) };
